import { LoadingValue } from "~/modules/dashboard/components/LoadingValue.tsx";
import { useKpiFigures } from "~/modules/dashboard/hooks/useKpiFigures.ts";
import { formatPercentage } from "~/utils/numberUtils.ts";

// Shows nothing for a user with no personal figures or when the figures fail: the KPI box already shows
// the error. While the figures load, it shows the label with a spinner, because `personal` is not known yet.
export function MonthUtilisation() {
	const { data, isPending } = useKpiFigures();

	if (!isPending && !data?.personal) return null;

	return (
		<p className="h-5 text-sm text-gray-500">
			Ø Auslastung Monat{" "}
			<span className="font-semibold text-gray-900">
				{data?.personal ? formatPercentage(data.personal.month.utilisationPercentage) : <LoadingValue size="line" className="min-w-10" />}
			</span>
		</p>
	);
}
